// Copy the entities area's screens and components added while moving to the design system (src/ui).
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const entitiesCopy = {
  nl: {
    "terroir.map.zoomIn": "Inzoomen",
    "terroir.map.zoomOut": "Uitzoomen",
    "terroir.map.about": "Over deze kaart",
  },
  en: {
    "terroir.map.zoomIn": "Zoom in",
    "terroir.map.zoomOut": "Zoom out",
    "terroir.map.about": "About this map",
  },
  de: {
    "terroir.map.zoomIn": "Vergrößern",
    "terroir.map.zoomOut": "Verkleinern",
    "terroir.map.about": "Über diese Karte",
  },
  fr: {
    "terroir.map.zoomIn": "Zoom avant",
    "terroir.map.zoomOut": "Zoom arrière",
    "terroir.map.about": "À propos de cette carte",
  },
  es: {
    "terroir.map.zoomIn": "Acercar",
    "terroir.map.zoomOut": "Alejar",
    "terroir.map.about": "Sobre este mapa",
  },
  it: {
    "terroir.map.zoomIn": "Ingrandisci",
    "terroir.map.zoomOut": "Riduci",
    "terroir.map.about": "Informazioni su questa mappa",
  },
  pt: {
    "terroir.map.zoomIn": "Aproximar",
    "terroir.map.zoomOut": "Afastar",
    "terroir.map.about": "Sobre este mapa",
  },
} as const;
